import { useMemo } from 'react';
import { useDeviceOS } from 'shared/hooks/use-device-os';

/**
 * useIsMobileImproved
 * Более надежное определение мобильного устройства (телефона), которое не зависит от разрешения экрана.
 * Использует User Agent и наличие тач-интерфейса из useDeviceOS.
 */
export const useIsMobileImproved = (): boolean => {
  const { isAndroid, isIOS, isTouchCapable } = useDeviceOS();

  return useMemo(() => {
    // Если это Android или iOS на основе User Agent, то мы считаем устройство мобильным,
    // даже если разрешение экрана 1920x1080 (например, в мобильных браузерах или OBS оверлеях)
    return isAndroid || isIOS || isTouchCapable;
  }, [isAndroid, isIOS, isTouchCapable]);
};

export default useIsMobileImproved;
